import createApiClient from './apiClient';

// Base env is …/api/students; district job APIs live under /api/jobs
const rootUrl = (process.env.REACT_APP_ATHENIAN_STUDENT_SERVICE_URL || '')
  .replace(/\/api\/students\/?$/, '');
const jobsApi = createApiClient(`${rootUrl}/api/jobs`);

export const getDistrictJobs = () =>
  jobsApi.get('/district');

export const pauseDistrictIntake = () =>
  jobsApi.post('/district/intake-pause');

export const resumeDistrictIntake = () =>
  jobsApi.post('/district/intake-resume');

export const pauseDistrictJob = (jobId) =>
  jobsApi.post(`/district/${encodeURIComponent(jobId)}/pause`);

export const startDistrictJob = (jobId) =>
  jobsApi.post(`/district/${encodeURIComponent(jobId)}/start`);

export const stopDistrictJob = (jobId) =>
  jobsApi.post(`/district/${encodeURIComponent(jobId)}/stop`);

export const restartDistrictJob = (jobId) =>
  jobsApi.post(`/district/${encodeURIComponent(jobId)}/restart`);
